import { toast, ToastOptions } from "react-hot-toast";
import { INotificationProps, Notification } from "./Notification";

type TShowNotification = Omit<INotificationProps, "id"> & {
  toastOptions?: ToastOptions;
};

export const showNotification = ({
  toastOptions = {},
  ...notificationProps
}: TShowNotification) => {
  toast.custom((t: ToastOptions) => (
    <Notification
      {...notificationProps}
      id={t.id}
    />
  ), toastOptions);
};
